export default "__VITE_ASSET__DT7aKvfn__"